"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var getChallengeConditions = function getChallengeConditions(conditions) {
  var onlyUnique = function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  };

  var result = Object.entries(conditions).reduce(function (acc, item) {
    var _item = (0, _slicedToArray2["default"])(item, 1),
        key = _item[0];

    var regex = /(min|max)(.*)/;
    var match = key.match(regex) || [];

    if (match.length > 0) {
      var _match = (0, _slicedToArray2["default"])(match, 3),
          conditionString = _match[2];

      return [].concat((0, _toConsumableArray2["default"])(acc), [conditionString.toLowerCase()]);
    }

    return acc;
  }, []).filter(onlyUnique);
  return result;
};

var _default = getChallengeConditions;
exports["default"] = _default;
//# sourceMappingURL=getChallengeConditions.js.map